import { useAtomValue } from "jotai"
import { useMemo } from "react"

import { studentAtoms } from "#atoms"
import {
  PORTFOLIO_AUTHOR_KIND,
  type PortfolioAuthorKind,
} from "#customTypes/composedTypes/portfolioTypes"
import { type Uuid } from "#customTypes/globalTypes"
import { useGetOneUser } from "#hooks/newHooks/useGetUser"

/**
 * Resolve display name for portfolio timeline / chat attribution.
 * TEACHER → `users` collection; STUDENT → `students`; missing kind defaults to TEACHER (legacy).
 */
export const usePortfolioAuthorName = (
  authorId: Uuid | string | undefined,
  authorKind?: PortfolioAuthorKind
): string => {
  const kind = authorKind ?? PORTFOLIO_AUTHOR_KIND.TEACHER
  const user = useGetOneUser(
    kind === PORTFOLIO_AUTHOR_KIND.TEACHER ? (authorId as Uuid) : null
  )
  const student = useAtomValue(
    studentAtoms.docByIdAtom(
      kind === PORTFOLIO_AUTHOR_KIND.STUDENT && authorId
        ? (authorId as Uuid)
        : null
    )
  )

  return useMemo(() => {
    if (!authorId) return ""
    if (kind === PORTFOLIO_AUTHOR_KIND.STUDENT) {
      return student?.name ?? String(authorId)
    }
    return user?.name ?? String(authorId)
  }, [authorId, kind, student?.name, user?.name])
}
